<header class="header">
  <div class="container header__inner">
    <a class="brand" routerLink="/">
      <img class="brand__logo" src="assets/images/WPlogo-clean-trim.png" alt="Western Packaging" />
    </a>

    <nav class="nav" aria-label="Primary">
      <a routerLink="/" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">
        {{ 'nav.home' | translate }}
      </a>
      <a routerLink="/products" routerLinkActive="is-active">
        {{ 'nav.products' | translate }}
      </a>
      <a routerLink="/about" routerLinkActive="is-active">
        {{ 'nav.about' | translate }}
      </a>
    </nav>

    <div class="lang">
      <span class="sr-only">{{ 'nav.language' | translate }}</span>
      <button
        *ngFor="let l of langs"
        type="button"
        class="btn lang__btn"
        [class.is-active]="current() === l.id"
        (click)="setLang(l.id)"
        [attr.aria-pressed]="current() === l.id"
      >
        {{ l.label }}
      </button>
    </div>
  </div>
</header>

